// extracted by mini-css-extract-plugin
export default {"root":"action_b_root__GKo8L","content":"action_b_content__4RX6i","title":"action_b_title__z9I0e","action":"action_b_action__8qSGj","image":"action_b_image__DDDqh"};